import MenuDivider from './components/MenuDivider';
import { ItemGroup } from 'rc-menu';
import { Menu as InnerMenu } from './components/Menu';
import { MenuItem } from './components/MenuItem';
import { SubMenu } from './components/SubMenu';
export var Menu = Object.assign(InnerMenu, {
  Item: MenuItem,
  SubMenu: SubMenu,
  ItemGroup: ItemGroup,
  Divider: MenuDivider
});